export const LanguageSelectionLabels = {
  "en-GB": { label: "English (UK)", flag: "🇬🇧" },
  "de-DE": { label: "Deutsch", flag: "🇩🇪" },
  "de-AT": { label: "Deutsch (Österreich)", flag: "🇦🇹" },
  "de-CH": { label: "Deutsch (Schweiz)", flag: "🇨🇭" },
  "fr-CH": { label: "Français (Suisse)", flag: "🇨🇭" },
  "fr-FR": { label: "Français", flag: "🇫🇷" },
  "fr-BE": { label: "Français (Belgique)", flag: "🇧🇪" },
  "nl-BE": { label: "Nederlands (België)", flag: "🇧🇪" },
  "nl-NL": { label: "Nederlands", flag: "🇳🇱" },
  "it-IT": { label: "Italiano", flag: "🇮🇹" },
  "pl-PL": { label: "Polski", flag: "🇵🇱" },
  "es-ES": { label: "Español", flag: "🇪🇸" },
  "pt-PT": { label: "Português", flag: "🇵🇹" },
  "tr-TR": { label: "Türkçe", flag: "🇹🇷" },
  "en-AU": { label: "English (Australia)", flag: "🇦🇺" },
  "en-NZ": { label: "English (New Zealand)", flag: "🇳🇿" },
  "en-HK": { label: "English (Hong Kong)", flag: "🇭🇰" },
  "zh-HK": { label: "繁體中文 (香港)", flag: "🇭🇰" },
  "en-TH": { label: "English (Thailand)", flag: "🇹🇭" },
  "th-TH": { label: "ไทย", flag: "🇹🇭" },
  "en-TW": { label: "English (Taiwan)", flag: "🇹🇼" },
  "zh-TW": { label: "繁體中文 (台灣)", flag: "🇹🇼" },
  "zh-CN": { label: "简体中文", flag: "🇨🇳" },
  "ja-JP": { label: "日本語", flag: "🇯🇵" },
  "ko-KR": { label: "한국어", flag: "🇰🇷" },
  "en-SG": { label: "English (Singapore)", flag: "🇸🇬" },
  "en-MY": { label: "English (Malaysia)", flag: "🇲🇾" },
  "en-IE": { label: "English (Ireland)", flag: "🇮🇪" },
  "en-ZA": { label: "English (South Africa)", flag: "🇿🇦" },
  "en-AE": { label: "English (UAE)", flag: "🇦🇪" },
  "en-EG": { label: "English (Egypt)", flag: "🇪🇬" },
  "en-MT": { label: "English (Malta)", flag: "🇲🇹" },
  "da-DK": { label: "Dansk", flag: "🇩🇰" },
  "no-NO": { label: "Norsk", flag: "🇳🇴" },
  "sv-SE": { label: "Svenska", flag: "🇸🇪" },
  "fi-FI": { label: "Suomi", flag: "🇫🇮" },
  "cs-CZ": { label: "Čeština", flag: "🇨🇿" },
  "sk-SK": { label: "Slovenčina", flag: "🇸🇰" },
  "sl-SI": { label: "Slovenščina", flag: "🇸🇮" },
  "hr-HR": { label: "Hrvatski", flag: "🇭🇷" },
  "hu-HU": { label: "Magyar", flag: "🇭🇺" },
  "et-EE": { label: "Eesti", flag: "🇪🇪" },
  "lt-LT": { label: "Lietuvių", flag: "🇱🇹" },
  "lv-LV": { label: "Latviešu", flag: "🇱🇻" },
  "el-CY": { label: "Ελληνικά (Κύπρος)", flag: "🇨🇾" },
  "el-GR": { label: "Ελληνικά", flag: "🇬🇷" },
  "ro-RO": { label: "Română", flag: "🇷🇴" },
  "bg-BG": { label: "Български", flag: "🇧🇬" },
  "uk-UA": { label: "Українська", flag: "🇺🇦" },
  "he-IL": { label: "עברית", flag: "🇮🇱", rtl: true },
  "ru-RU": { label: "Русский", flag: "🇷🇺" },
  en: { label: "English", flag: "🌐" },
};

export const getLanguageMetaByLocale = (locale) => {
  const normalized = locale?.toLowerCase();
  return (
    Object.entries(LanguageSelectionLabels).find(
      ([key]) => key.toLowerCase() === normalized,
    )?.[1] ?? null
  );
};
